import { render, staticRenderFns } from "./DetailVacancy.vue?vue&type=template&id=17beb09e&scoped=true"
import script from "./DetailVacancy.vue?vue&type=script&lang=js"
export * from "./DetailVacancy.vue?vue&type=script&lang=js"
import style0 from "./DetailVacancy.vue?vue&type=style&index=0&id=17beb09e&prod&lang=scss&scoped=true"
import style1 from "./DetailVacancy.vue?vue&type=style&index=1&id=17beb09e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17beb09e",
  null
  
)

export default component.exports